import { Component, OnDestroy, ViewChild, OnInit, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CreateNewStyleGroupComponent } from '../create-new-style-group/create-new-style-group.component';
import { CollectionService } from '@services/collection.service';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@services/notification.service';
import { WebErrorService } from '@services/webError.service';
import { CreateNewStyleComponent } from '../create-new-style/create-new-style.component';
import { TranslateService } from '@ngx-translate/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-collection-style-groups',
  templateUrl: './collection-style-groups.component.html',
  styleUrls: ['./collection-style-groups.component.scss']

})

export class CollectionStyleGroupsComponent implements OnInit,OnDestroy {
  globalcollectionuuId: any;
  displayedColumns: string[] = [
    'Stylegroup',
    'Styles',
    'Updated',
    'Action',
  ];
  dataSource: MatTableDataSource<any>;
  noDataFound: boolean = false;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) set content(sort: MatSort) {
  //   // this.dataSource.sort = sort;
  // }

  @ViewChild(MatSort, { static: false }) sort: MatSort;


  StyleGroupSubscription$: Subscription

  isStyleGroupadded: boolean = true;
  isStyleDetails: boolean = false;
  styleGroupDetail: any;
  styleGroupData: any;
  Style: any;
  StyleGroup: any;
  @ViewChild('deleteError') private deleteError: TemplateRef<any>;
  deleteErrorMsg: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(public dialog: MatDialog,
    private CollectionService: CollectionService,
    private router: Router,
    private notificationService: NotificationService,
    private webErrorService: WebErrorService,
    private cd: ChangeDetectorRef,
    private translate: TranslateService,
    private routerstate: ActivatedRoute,) {
    this.globalcollectionuuId = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
  }


  ngOnInit(): void {
    this.getStyleGroups();

    this.CollectionService.onBackStyleGroupDetails.subscribe(d => {
      this.isStyleDetails = d;
      this.isStyleGroupadded = true;
      this.getStyleGroups();
    });
  }

  openNewStyleDialog(): void {
    const dialogSubscription = this.dialog.open(CreateNewStyleGroupComponent, { minWidth: '650px' }).afterClosed().subscribe(result => {
      this.getStyleGroups();
      dialogSubscription.unsubscribe();
    });
  }

  getStyleGroups() {
    this.CollectionService.getStyleGroups(this.globalcollectionuuId).subscribe(data => {
      if (data.data.length > 0) {
        this.styleGroupData = data.data;
        this.dataSource = new MatTableDataSource(data.data);

        this.cd.detectChanges();

        setTimeout(() => {
          this.dataSource.paginator = this.paginator;
          if(this.dataSource.paginator) {
            // ------Set translation for pagination------
            this.translate.stream([
              'collectionById.styleGroups.pagination.pageLabel',
              'collectionById.styleGroups.pagination.firstPage',
              'collectionById.styleGroups.pagination.lastPage',
              'collectionById.styleGroups.pagination.nextPage',
              'collectionById.styleGroups.pagination.prevPage'
            ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
                this.dataSource.paginator._intl.itemsPerPageLabel = translation['collectionById.styleGroups.pagination.pageLabel'];
                this.dataSource.paginator._intl.firstPageLabel = translation['collectionById.styleGroups.pagination.firstPage'];
                this.dataSource.paginator._intl.lastPageLabel = translation['collectionById.styleGroups.pagination.lastPage'];
                this.dataSource.paginator._intl.nextPageLabel = translation['collectionById.styleGroups.pagination.nextPage'];
                this.dataSource.paginator._intl.previousPageLabel = translation['collectionById.styleGroups.pagination.prevPage'];

                this.dataSource.paginator._intl.changes.next();
            });
          }

        });

        this.isStyleGroupadded = false;
      } else {
        this.dataSource = new MatTableDataSource([]);
        this.dataSource.paginator = this.paginator;
        this.isStyleGroupadded = true;
      }
    });
  }

  onSearch(styleGroupName: string, styles: string): any {
    // this.dataSource.filterPredicate = function(data, filter: string): boolean {
    //   return data.styleGroupName.toLowerCase().includes(filter) || data.styles.toLowerCase().includes(filter)
    // };

    // if (inputValue != '') {
    //   this.dataSource.filter = inputValue.trim().toLowerCase();
    // }
    // if (input2 != '') {
    //   this.dataSource.filter = input2.trim().toLowerCase();
    // }

    // this.dataSource.paginator = this.paginator;
    // if (this.dataSource.filteredData.length > 0) {
    //   this.noDataFound = false;
    // } else {
    //   this.noDataFound = true;
    // }

    // if (this.dataSource.paginator) {
    //   this.dataSource.paginator.firstPage();
    // }
    const filterObj = {
      styleGroupName: styleGroupName,
      styleName: styles
    }

    if(this.StyleGroupSubscription$){this.StyleGroupSubscription$.unsubscribe()}

    this.StyleGroupSubscription$ =
      this.CollectionService.getFilterStyleGroup(filterObj, this.globalcollectionuuId).subscribe(resData => {
        this.styleGroupData = resData.data;
        if (this.styleGroupData && !this.styleGroupData.length) {
          this.noDataFound = true;
        } else {
          this.dataSource = new MatTableDataSource(this.styleGroupData);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.noDataFound = false;
        }
      },(error)=>{
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      },() => { }) || undefined;

  }

  onReset() {
    this.Style = ''
    this.StyleGroup = ''
    this.getStyleGroups();
    this.noDataFound = false
  }

  deleteStyleGroup(row): void {
    const dialogRef = this.dialog.open(DelMessageComponent, { data: { message: this.translate.instant('collectionById.styleGroups.deletePopup.message'), buttonText: { ok: this.translate.instant('collectionById.styleGroups.deletePopup.btnYes'), cancel: this.translate.instant('collectionById.styleGroups.deletePopup.btnNo') } } });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.CollectionService.deleteStyleGroup(this.globalcollectionuuId, row.styleGroupId).subscribe(data => {
          this.getStyleGroups();
          this.notificationService.success(data.message);
        }, (error: any) => {
          this.dialog.open(this.deleteError, { width: '700px' });
          this.deleteErrorMsg = error.error.message;
        });
      }
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  styleGroupDetails(row) {
    this.isStyleDetails = true;
    this.styleGroupDetail = row;
    // this.router.navigate(['/collections', this.globalcollectionuuId, 'styeGroup', row.styleGroupId], { relativeTo: this.routerstate });
    // this.router.navigate(['/styeGroup', row.styleGroupId]);
  }

  createStyle(row) {
    const dialogSubscription = this.dialog.open(CreateNewStyleComponent, { minWidth: '650px', data: { type: true, row: row, styleGroupId: row.styleGroupId } }).afterClosed().subscribe(result => {
      this.getStyleGroups();
      dialogSubscription.unsubscribe();
    });
  }

  ngOnDestroy(): void {
    if(this.StyleGroupSubscription$){this.StyleGroupSubscription$.unsubscribe()}

  }
}
